/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import ViewDocumentAttachments from "./DocumentAttachment";
import Breadcrumbs from "components/Breadcrumbs";
import { useNavigate, useLocation, useParams, useSearchParams } from "react-router-dom";
import { getDocumentDetailApi } from "api/services/documents";
import { useDocument } from "./../context/documentContext";
import { getExpiryMeta } from "../components/expiry";
import DocumentStatusBadge from "../components/DocumentStatusBadge";
import { useSelector } from "react-redux";
import AllDocumentAddPopup from "../../../../components/modelpopup/AllDocumentAddPopup";
import Image from "components/Image";
import { formatDateHandler2 } from "utils/common";
import { useMediaQuery } from "react-responsive";


const DocumentDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  
  // Get document type from query params
  const documentTypeFromUrl = searchParams.get('type') || 'user';
  const {
    loading,
    documentData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDocumentDetailPage,
    selectedPage,
    setSelectedPage,
    documentModal,
    setSelectedDocument,
    setDocumentModal,
    selectedDocument,
    setLoading,
    documentType,
    documentTypeLoading,
    storeType,
    setDocumentArchived,
  } = useDocument();
  const { user } = useSelector((state) => state.user);


  const [documentDetail, setDocumentData] = useState({});
  const [attachmentData, setAttachmentData] = useState([]) 
  useEffect(() => {


    console.log(location, navigate, params, "LLL");
    if (params?.id) {
      getDocumentList()
    }
  }, [params?.id, documentType]);
  const getDocumentList = ()=>{
    getDocumentDetailApi(params?.id).then((response) => {
      console.log(response, "REEEEEEE");
      setDocumentData(response.data);

      const attachmentData =  [
        { id: 1, title: "Document Name", text:response.data?.name},
        { id: 2, title: "Document Type", text: documentType.find(item=>item.id ==response.data?.document_type?.id)?.name },
        { id: 3, title: "Issue Date", text:formatDateHandler2(response.data?.issue_date)},
        { id: 4, title: "Expiry Date", text:formatDateHandler2(response.data?.expiry_date)},
        { id: 5, title: "Expires In", text: getExpiryMeta(response.data).label },
     
       
    
      ]
      setAttachmentData(attachmentData) 

    });
  }
  // Archive / restore from the detail page; same rule as the row menu.
  const canManage = documentDetail?.id && (user?.role?.access_scope == "all" || user?.id == documentDetail?.company_user?.id);
  const handleToggleArchive = () =>
    setDocumentArchived(documentDetail.id, documentDetail.status !== false).then(() => getDocumentList()).catch(() => {});

  const getIndex = useMemo(()=>{

    console.log(documentData, documentDetail, "KKKKKKKKKKKKKKKKKKKKKK")
    const index = documentData.findIndex(doc => doc.id === documentDetail.id);
    return index
    
  },[documentData, documentDetail])

  const handleClickGoBack = () => {
    // Use type from query params to determine where to navigate back to
    const type = documentTypeFromUrl || (storeType === 'store' || documentDetail?.store ? 'store' : 'user');
    if (type === 'store') {
      navigate('/documents/store');
    } else {
      navigate('/documents');
    }
  };

  const handleClickNext = () => {
    const nextIndex = getIndex + 1;
    console.log(nextIndex,getIndex, "LLLL")
    if (nextIndex < pageSettings.total) {
      let nextDocument = documentData[nextIndex];
      // Preserve type parameter when navigating to next document
      const typeParam = documentTypeFromUrl === 'store' ? 'type=store' : 'type=user';
      navigate(`/documents/${nextDocument.id}?${typeParam}`);
      setSelectedPage(nextIndex);
    }
  };

  const handleClickPrevious = () => {
    const prevIndex = getIndex - 1;
    if (prevIndex >= 0) {
      let nextDocument = documentData[prevIndex];
      // Preserve type parameter when navigating to previous document
      const typeParam = documentTypeFromUrl === 'store' ? 'type=store' : 'type=user';
      navigate(`/documents/${nextDocument.id}?${typeParam}`);
      setSelectedPage(prevIndex);
    }
  };

  const createDocumentHandler = () => {

  }
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid" style={{ padding: isMobile ? "12px 8px" : "16px" }}>













          {/* Header with Navigation */}
          <div style={{ 
            marginBottom: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "12px"
          }}>
            <div>
              <h2 style={{ 
                fontSize: isMobile ? "18px" : "20px",
                fontWeight: "600",
                color: "#1f2937",
                margin: 0
              }}>
                Document Detail
              </h2>
              <Link 
                to={documentTypeFromUrl === 'store' ? "/documents/store" : "/documents"} 
                onClick={(e) => {
                  e.preventDefault();
                  handleClickGoBack();
                }}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "rgb(211, 0, 26)",
                  textDecoration: "none",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginTop: "6px"
                }}
                    >
                <i className="las la-arrow-left"></i>
                Back to Documents
                    </Link>
              </div>
            
            {/* Pagination Controls */}
            {documentData.length > 0 && (
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "12px"
              }}>
                <span style={{ 
                  fontSize: "13px",
                  color: "#6b7280",
                  fontWeight: "500"
                }}>
                  {getIndex + 1} of {pageSettings.total}
                </span>
                <div style={{ display: "flex", gap: "6px" }}>
                      <Link
                    to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleClickPrevious();
                        }}
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "6px",
                      background: getIndex > 0 ? "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)" : "#e5e7eb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: getIndex > 0 ? "#ffffff" : "#9ca3af",
                      textDecoration: "none",
                      cursor: getIndex > 0 ? "pointer" : "not-allowed",
                      boxShadow: getIndex > 0 ? "0 2px 8px rgba(211, 0, 26, 0.2)" : "none"
                    }}
                      >
                    <i className="las la-arrow-left"></i>
                      </Link>
                      <Link
                    to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleClickNext();
                        }}
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "6px",
                      background: getIndex + 1 < pageSettings.total ? "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)" : "#e5e7eb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: getIndex + 1 < pageSettings.total ? "#ffffff" : "#9ca3af",
                      textDecoration: "none",
                      cursor: getIndex + 1 < pageSettings.total ? "pointer" : "not-allowed",
                      boxShadow: getIndex + 1 < pageSettings.total ? "0 2px 8px rgba(211, 0, 26, 0.2)" : "none"
                    }}
                      >
                    <i className="las la-arrow-right"></i>
                      </Link>
                </div>
              </div>
            )}
          </div>

          {/* Main Document Card */}
          <div className="card shadow-sm" style={{ 
            borderRadius: "8px",
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
            marginBottom: "16px",
            position: "relative"
          }}>
            <div style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              zIndex: 10,
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}>
              {canManage && (
                <button
                  type="button"
                  onClick={handleToggleArchive}
                  title={documentDetail.status === false ? "Restore this document" : "Archive this document (it stays on record)"}
                  style={{
                    height: "32px",
                    padding: isMobile ? "0 9px" : "0 12px",
                    borderRadius: "6px",
                    border: "1px solid #e5e7eb",
                    background: "#ffffff",
                    color: "#374151",
                    fontSize: "12px",
                    fontWeight: 600,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer"
                  }}
                >
                  <i className={`las ${documentDetail.status === false ? "la-box-open" : "la-archive"}`} aria-hidden="true" style={{ fontSize: "15px" }} />
                  {!isMobile && (documentDetail.status === false ? "Restore" : "Archive")}
                </button>
              )}
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedDocument(documentDetail);
                  setDocumentModal(true);
                }}
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "6px",
                  background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  textDecoration: "none",
                  boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)",
                  transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(211, 0, 26, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(211, 0, 26, 0.2)";
                }}
              >
                <i className="fa-solid fa-pencil" style={{ fontSize: "14px" }}></i>
              </Link>
            </div>

            <div className="card-body" style={{ padding: isMobile ? "16px" : "20px" }}>
              {/* Document Name - Main Highlight */}
              <div style={{ marginBottom: "16px", paddingRight: isMobile ? "90px" : "170px" }}>
                <h1 style={{ 
                  fontSize: isMobile ? "18px" : "22px",
                  fontWeight: "700",
                  color: "#1f2937",
                  marginBottom: "8px",
                  lineHeight: "1.2"
                }}>
                  {documentDetail?.name || "Untitled Document"}
                </h1>
                {documentDetail?.document_type?.name && (
                  <span className="badge badge-soft-info" style={{
                    fontSize: "12px",
                    padding: "4px 10px",
                    borderRadius: "4px",
                    fontWeight: "500"
                  }}>
                    {documentDetail.document_type.name}
                  </span>
                )}
                {documentDetail?.id && (
                  <DocumentStatusBadge
                    document={documentDetail}
                    style={{ fontSize: "12px", padding: "4px 10px", borderRadius: "4px", fontWeight: "500", marginLeft: "6px" }}
                  />
                )}
          </div>

              {/* Document Information Grid */}
              <div style={{
                borderTop: "1px solid #e5e7eb",
                paddingTop: "16px",
                marginBottom: "16px"
              }}>
                <div className="row g-2">
                  {attachmentData.map((item, index) => (
                    <div key={item.id} className={isMobile ? "col-12" : "col-md-6"}>
                      <div style={{
                        background: "#ffffff",
                        padding: "12px",
                        borderRadius: "6px",
                        border: "1px solid #e5e7eb"
                      }}>
                        <div style={{ 
                          fontSize: "11px", 
                          color: "#9ca3af", 
                          marginBottom: "4px",
                          fontWeight: "500",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px"
                        }}>
                          {item.title}
                        </div>
                        <div style={{ 
                          fontSize: "14px", 
                          color: "#1f2937",
                          fontWeight: "600"
                        }}>
                          {item.text || "N/A"}
                        </div>
                      </div>
                    </div>
                  ))}
                        </div>                       
                      </div>

              {/* Attachments Section */}
                <ViewDocumentAttachments documentDetail={documentDetail} />
           
              {/* Employee Info - De-emphasized */}
              {documentDetail?.company_user && (
                <div style={{
                  borderTop: "1px solid #e5e7eb",
                  paddingTop: "16px",
                  marginTop: "16px"
                }}>
                  <div style={{ 
                    fontSize: "11px",
                    color: "#9ca3af",
                    marginBottom: "8px",
                    fontWeight: "500",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px"
                  }}>
                    Employee Information
                  </div>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    background: "#f9fafb",
                    padding: "12px",
                    borderRadius: "6px"
                  }}>
                    <div style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "2px solid #e5e7eb",
                      flexShrink: 0,
                      background: "#ffffff"
                    }}>
                      <Image 
                        src={documentDetail.company_user?.profile_image} 
                        alt="User" 
                        placeholder={"user"}
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "100%"
                        }}
                      />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ 
                        fontSize: "14px", 
                        color: "#1f2937",
                        fontWeight: "600",
                        marginBottom: "2px"
                      }}>
                        <Link
                          to={`/employees/${documentDetail.company_user?.id}`}
                          style={{ color: "inherit", textDecoration: "underline", textDecorationColor: "#d1d5db", textUnderlineOffset: "3px" }}
                        >
                          {documentDetail.company_user?.first_name} {documentDetail.company_user?.last_name}
                        </Link>
                        </div>
                      <div style={{ 
                        fontSize: "12px", 
                        color: "#6b7280",
                        marginBottom: "2px"
                      }}>
                        {documentDetail.company_user?.emp_no}
                      </div>
                      {documentDetail.company_user?.position_name && (
                        <div style={{ 
                          fontSize: "12px", 
                          color: "#6b7280",
                          marginBottom: "2px"
                        }}>
                          {documentDetail.company_user.position_name}
                        </div>
                      )}
                      {documentDetail.company_user?.email && (
                        <div style={{ 
                          fontSize: "12px", 
                          color: "#6b7280",
                          marginBottom: "0"
                        }}>
                          {documentDetail.company_user.email}
                    </div>
                      )}
                    </div>
                    <Link
                      to={`/employees/${documentDetail.company_user?.id}`}
                      style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "12px", fontWeight: "600", color: "rgb(211, 0, 26)", textDecoration: "none", whiteSpace: "nowrap", flexShrink: 0 }}
                    >
                      View profile <i className="las la-arrow-right" aria-hidden="true" />
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>

          <AllDocumentAddPopup 
            getDocumentList={getDocumentList} 
            documentType={documentType} 
            documentTypeLoading={documentTypeLoading} 
            setSelectedDocument={setSelectedDocument} 
            setLoading={setLoading} 
            selectedDocument={selectedDocument} 
            loading={loading} 
            createDocumentHandler={createDocumentHandler} 
            documentModal={documentModal} 
            setDocumentModal={setDocumentModal} 
            storeType={storeType} 
          />

        </div>
      </div>
    </>
  );
};

export const ListItem = ({ title, text }) => (
  <li>
    <div className="title">{title}</div>
    <div className="text">{text}</div>
  </li>
);

export default DocumentDetail;
